import { ReactComponent as FAQ } from "../../../assets/imgs/icons/faq.svg";
import { ReactComponent as Data } from "../../../assets/imgs/icons/data.svg";
import { ReactComponent as Point } from "../../../assets/imgs/icons/point.svg";
import { ReactComponent as Legal } from "../../../assets/imgs/icons/legal.svg";
import { ReactComponent as Locked } from "../../../assets/imgs/icons/locked.svg";
import { ReactComponent as Share } from "../../../assets/imgs/icons/share.svg";
import { ReactComponent as Person } from "../../../assets/imgs/icons/person.svg";
import { ReactComponent as Mail } from "../../../assets/imgs/icons/mail.svg";


export const privacyData = {
  title: "Політика конфіденційності",
  subtitle:
    'Як ми збираємо, використовуємо та захищаємо вашу особисту інформацію в рамках сервісу "Живі спогади".',
  blocks: {
    lead: {
      icon: <FAQ />,
      title: "1. Вступ",
      description:
        "Ми поважаємо конфіденційність та захист персональних даних наших клієнтів. Ця політика пояснює, як ми збираємо, використовуємо, зберігаємо та захищаємо вашу персональну інформацію. Ми дотримуємося Загального регламенту про захист даних (GDPR) та українського законодавства у цій галузі.",
    },
    first_group: [
      {
        icon: <Data />,
        title: "2. Які дані ми збираємо",
        subtitle: "Ми збираємо такі категорії персональних даних:",
        description: [
          {
            title: "Контактна інформація",
            listItems: [
              `Ім'я та прізвище`,
              "Адреса електронної пошти",
              "Номер телефону",
              "Поштова адреса (за потреби)",
            ],
          },
          {
            title: "Платіжні дані",
            listItems: [
              "Платіжна інформація",
              "Банківські реквізити (через захищені процесори)",
              "Історія замовлень",
              "Налаштування оплати",
            ],
          },
          {
            title: "Візуальний контент",
            listItems: [
              "Завантажені фотографії",
              "Специфікації проекту",
              "Коментарі та відгуки",
              "Естетичні вподобання",
            ],
          },
          {
            title: "Технічні дані",
            listItems: [
              "IP-адреса",
              "Браузер і пристрій",
              "Відвідані сторінки",
              "Час, проведений на сайті",
            ],
          },
        ],
      },
      {
        icon: <Locked />,
        title: "3. Зберігання та безпека даних",
        subtitle: "Ми впроваджуємо надійні заходи безпеки:",
        description: [
          {
            title: "Технічні заходи",
            listItems: [
              "SSL/TLS-шифрування",
              "Безпечні сервери",
              "Регулярні резервні копії",
              "Багатофакторна автентифікація",
            ],
          },
          {
            title: "Організаційні заходи",
            listItems: [
              "Обмежений доступ",
              "Навчання персоналу",
              "Сувора внутрішня політика",
              "Регулярні аудити",
            ],
          },
        ],
      },
    ],
    second_group: [
      {
        icon: <Point />,
        title: "4. Мета використання даних",
        subtitle: "Ми використовуємо ваші персональні дані для того, щоб:",
        listItems: [
          {
            title: "Надання послуг:",
            subtitle: "Колорування, реставрація та створення відео",
          },
          {
            title: "Зв'язок:",
            subtitle: "Оновлення проекту, технічна підтримка",
          },
          {
            title: "Виставлення рахунків:",
            subtitle: "Виставлення рахунків-фактур та обробка платежів",
          },
          {
            title: "Покращення послуг:",
            subtitle: "Аналіз зворотного зв'язку та оптимізація процесів",
          },
          {
            title: "Маркетинг (лише за вашої згоди):",
            subtitle: "Розсилка новин та спеціальні пропозиції",
          },
          {
            title: "Дотримання законодавчих вимог:",
            subtitle: "Дотримання податкових та юридичних зобов'язань",
          },
        ],
      },
      {
        icon: <Legal />,
        title: "5. Правова основа обробки",
        subtitle: "Ми обробляємо ваші дані на таких правових підставах:",
        listItems: [
          {
            title: "Виконання договору:",
            subtitle: "Виконання замовлених послуг",
          },
          {
            title: "Законний інтерес:",
            subtitle: "Покращення послуг та технічної підтримки",
          },
          {
            title: "Згода:",
            subtitle:
              "Для маркетингової діяльності (можна відкликати будь-коли)",
          },
          {
            title: "Юридичне зобов'язання:",
            subtitle: "Дотримуватися податкових норм",
          },
        ],
      },
      {
        icon: <Share />,
        title: "6. Обмін даними з третіми сторонами",
        subtitle:
          "Ми не продаємо ваші персональні дані третім сторонам. Ми ділимося інформацією лише з:",
        listItems: [
          {
            title: "Хмарні сервіси:",
            subtitle: "Для безпечного зберігання фотографій",
          },
          {
            title: "Постачальники послуг електронної пошти:",
            subtitle: "Для важливого зв'язку",
          },
          {
            title: "Компетентні органи:",
            subtitle: "Тільки якщо це вимагається законом",
          },
        ],
      },
      {
        icon: <Person />,
        title: "7. Ваші права",
        subtitle: "Згідно з GDPR, ви маєте такі права:",
        listItems: [
          {
            title: "Право доступу:",
            subtitle:
              "Ви можете запросити копію даних, які ми зберігаємо про вас",
          },
          {
            title: "Право на виправлення:",
            subtitle:
              "Ви можете вимагати виправлення неточних або неповних даних",
          },
          {
            title: "Право на видалення:",
            subtitle: "Ви можете вимагати видалення даних за певних умов",
          },
          {
            title: "Переносимість даних:",
            subtitle: "Ви можете отримати дані у структурованому форматі",
          },
        ],
      },
      {
        icon: <Person />,
        title: "8. Використання файлів cookie",
        subtitle: "Ми використовуємо файли cookie для того, щоб:",
        listItems: [
          {
            title: "Необхідні файли cookie:",
            subtitle: "Для функціонування сайту",
          },
          {
            title: "Файли cookie для продуктивності:",
            subtitle: "Для аналізу трафіку (Google Analytics)",
          },
          {
            title: "Файли cookie для налаштувань:",
            subtitle: "для запам'ятовування ваших налаштувань",
          },
        ],
      },
    ],
    support: {
      icon: <Mail />,
      title: "9. Контакти та підтримка",
      subtitle:
        "Якщо у вас є запитання щодо цих умов, ви можете зв’язатися з нами:",
      listItems: [
        {
          title: "Електронна пошта:",
          subtitle: "zivispogadi@gmail.com",
        },
        {
          title: "Телефон:",
          subtitle: "+380756921959",
        },
        {
          title: "Графік роботи:",
          subtitle: "понеділок - п'ятниця, 09:00 - 18:00",
        },
      ],
    },
  },
};
